import { useEffect } from 'react';
import { handleAxiosError } from 'utils/helpers';

interface UseNotifyErrorProps {
  error: Error | null;
  msg?: string;
}

const useNotifyError = ({ error, msg }: UseNotifyErrorProps): void => {
  useEffect(() => {
    if (error) handleAxiosError(error, msg);
  }, [error, msg]);
};

export default useNotifyError;
